import { VIZIT_ENV } from '@vizit/constants';

// Pendo will only be enabled if there is an API key in the environment variables.
// Local development should not have an API key. Check your dev-personal branch in doppler to make sure.
if (import.meta.env.VITE_HELP_SCOUT_BEACON_ID) {
  const organizationId = localStorage.getItem('organization_id');
  const userId = localStorage.getItem('user_id');
  const organizationName = localStorage.getItem('organization_name');
  const userEmail = localStorage.getItem('user_email');

  // In order to avoid collisions in Pendo, we need to prefix the user and account IDs with the environment.
  const envUserId = userId && VIZIT_ENV !== 'prod' ? `${VIZIT_ENV}-${userId}` : userId;
  const envOrganizationId = organizationId && VIZIT_ENV !== 'prod' ? `${VIZIT_ENV}-${organizationId}` : organizationId;

  // To debug Pendo, in browser console, enter pendo.enableDebugging(). This will show you all the Pendo configuration and events.
  window.Beacon('init', import.meta.env.VITE_HELP_SCOUT_BEACON_ID);

  if (userEmail && userEmail !== '') {
    window.Beacon('identify', {
      email: userEmail,
      ...(organizationName && organizationName !== '' ? { company: organizationName } : undefined),
    });
  }

  if (envUserId && envOrganizationId) {
    window.Beacon('session-data', {
      user_id: envUserId,
      organization_id: envOrganizationId,
    });
  }
}
